import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GlobalTypes } from 'redux/types';

export enum FeatureKey {
  MERCHANT_REFERENCE = 'merchant_reference',
}

interface UseFeatureResult {
  enabled: boolean;
  feature: any;
}

export const useFeature = (key: FeatureKey): UseFeatureResult => {
  const features = useSelector((state: GlobalTypes.RootState) => state.auth.features);

  return useMemo(() => {
    const feature = features?.[key] ?? null;
    const enabled = feature?.enable ?? false;

    return {
      enabled,
      feature,
    };
  }, [features, key]);
};
